define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetView  = require("shared/ui/experience/widgets/AbstractWidgetView");
    const TextWidgetView      = require("shared/ui/experience/widgets/textWidget/TextWidgetView");
    const WebFontsUtil        = require("shared/ui/experience/fonts/WebFontsUtil");

    /**
     * Mixin the editor related logic for the <tt>TextWidgetView</tt>.
     *
     * @see  TextWidgetView
     */
    return TextWidgetView.mixin("TextWidgetViewEditorMixin", {

        modelEvents: {
            // renders are being prevented (see TextEditorController#saveModel) when editing a text
            // widget, however for text widget views (say, a representation of the an overlay on
            // another scene) it does need to update.
            // TODO: Method should be defined as a class method and called by a string to follow the style guide and for better readability,
            // but this causes the scope to be removed, possibly related to using mixins
            "content:updated"() {
                const isBeingEdited = this.$el.attr("contenteditable") === "true";

                if (!isBeingEdited) {
                    this.render();
                }
            }
        },

        initialize() {
            this.__super();
            this.listenTo(this, "update", () => {
                this.ieFontHack();
            });
        },

        updateRendering() {
            this.__super();
            this.ieFontHack();
        },

        onRender() {
            this.contentCompatibilityCheck();
            WebFontsUtil.fontCompatibilityCheck(this.model);

            var onRender = AbstractWidgetView.prototype.onRender;

            if (onRender) {
                onRender.apply(this, _.toArray(arguments));
            }
        },

        onShow() {
            this.__super();

            // Since abstractView defers, we also need to defer this in order to get correct width
            _.defer(() => {
                // Runs after showView, so that we can get correct width
                this.widthCompatibilityCheck();
            });
        },

        /**
         * Old widgets uses \n to break line, whereas new widgets need <br>
         */
        contentCompatibilityCheck() {
            this.model.set("text", this.model.get("text").replace("\n", "<br/>"));
        },

        widthCompatibilityCheck() {
            // Add width for the old experiences
            if (!this.model.has("width")) {
                const unscaledExperienceSize = this._experienceSize();

                let width = this.$el.width();

                if (width) {
                    // Legacy text widgets are rendered using different CSS
                    // settings and different fonts have different widths in
                    // different browsers. For this reason we give it some
                    // buffering to work with.
                    width += 10;

                    // Silently update the width (avoid re-rendering) and make sure to recompute any
                    // affected computed properties (hint: scaledWidth)
                    this.model.set({width: width / unscaledExperienceSize.width * 100}, {silent: true});
                    this.model.invalidateComputedProperties("width", true);
                }
            }
        },

        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight() {
            // Highlight widget if required
            if (this.model.get("highlighted")) {
                this.$el.css({
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("boxShadow")) {
                this.$el.css({
                    boxShadow: "inset 0px 0px 0px 0px transparent"
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textWidget/TextWidgetViewEditorMixin.js